<script>
export default {
    name: 'IconGraduate'
}
</script>
<template>
    <svg
        class="base-icon icon-graduate"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M32 28c8.955 0 16.536 5.886 19.084 14C48.536 50.113 40.955 56 32 56s-16.536-5.886-19.084-14C15.464 33.887 23.045 28 32 28zm0-20l16 6 .001 10.063a2 2 0 11-1.001 0v-9.688l-7.06 2.647c.03.24.049.483.056.729L40 18a8 8 0 11-15.94-.978L16 14l16-6z"
            fill="currentColor"
            fill-rule="evenodd"
        />
    </svg>
</template>
